import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import UserRegister from '../views/UserRegister.vue'
import WeeklyPaper from '../views/WeeklyPaper.vue'
import WeeklyPaperUpload from '../views/WeeklyPaperUpload'
import Announcement from '../views/Announcement.vue'
import Bus from '../views/Bus'
import Car from '../views/Car'
import Driver from '../views/Driver'
import Manager from '../views/Manager'
import Stations from '../views/Stations'
import RouteGroup from '../views/RouteGroup'
import Route from '../views/Route'
import Users from '../views/Users'
import Parking from '../views/Parking'
import UserMain from '../views/UserMain'
import CarSearch from '../views/CarSearch'

Vue.use(VueRouter)

const routes = [
  {
    path: '/admin',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: Login,
    meta: {
      isNoHeader: true,
      isNoLeftMenu: true
    }
  },
  {
    path: '/admin/user-register',
    name: 'UserRegister',
    component: UserRegister,
    meta: {
      isNoHeader: true,
      isNoLeftMenu: true
    }
  },
  {
    path: '/admin/weekly-paper',
    name: 'WeeklyPaper',
    component: WeeklyPaper
  },
  {
    path: '/admin/weekly-paper-upload',
    name: 'WeeklyPaperUpload',
    component: WeeklyPaperUpload
  },
  {
    path: '/admin/announcement',
    name: 'Announcement',
    component: Announcement
  },
  {
    path: '/admin/bus',
    name: 'bus',
    component: Bus
  },
  {
    path: '/admin/car',
    name: 'car',
    component: Car
  },
  {
    path: '/admin/driver',
    name: 'driver',
    component: Driver
  },
  {
    path: '/admin/manager',
    name: 'manager',
    component: Manager
  },
  {
    path: '/admin/stations',
    name: 'Stations',
    component: Stations
  },
  {
    path: '/admin/route-group',
    name: 'RouteGroup',
    component: RouteGroup
  },
  {
    path: '/admin/route',
    name: 'Route',
    component: Route
  },
  {
    path: '/admin/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/admin/parking',
    name: 'Parking',
    component: Parking
  },
  {
    path: '/car-search',
    name: 'CarSearch',
    component: CarSearch,
    meta: {
      isNoHeader: true,
      isNoLeftMenu: true
    }
  },
  {
    path: '/',
    name: 'UserMain',
    component: UserMain,
    meta: {
      isNoHeader: true,
      isNoLeftMenu: true,
      isUserMain: true
    }
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
